import { all, call, put, select, takeLatest } from "redux-saga/effects";

import {
  getRequestLeaveDetailStart,
  getRequestLeaveDetailSuccess,
  getRequestLeaveDetailFailed,
} from "../redux/getRequestLeaveDetail";
import { getRequestLeaveDetailAPI } from "core/http/service/decleareLeave";
import { selectIdRequestLeaveDetail } from "../redux/selector";
import {
  calculateTotalLeaveDay,
  formReqLeaveLongTermUpdate,
  formReqLeaveUpdate,
  updateTotalLeaveDay,
} from "../redux/formReqLeave";
import { TypeSelect } from "../redux/formReqArrivingLateLeaveEarly";
import moment from "moment";
import { listApprover } from "../components/CustomCalendarTimeKeeping/const";
import { toast } from "react-toastify";
import { ErrorMessage } from "core/http/service/decleareLeave/const";
import { setEarlyRegistrationFormInput } from "../redux/earlyRegistation";

function* getRequestLeaveDetailWork() {
  const id = yield select(selectIdRequestLeaveDetail);
  try {
    const res = yield call(getRequestLeaveDetailAPI, id);
    const totalLeaveDay = calculateTotalLeaveDay(res?.details);
    yield put({
      type: updateTotalLeaveDay.type,
      payload: totalLeaveDay,
    });
    let listApproverCode = {};
    res?.approvals.forEach((item, index) => {
      listApproverCode = {
        ...listApproverCode,
        [listApprover[index]]: item.approverCode,
      };
    });
    const payloadForm = {
      type: res?.type,
      relatedPersonCodes:
        res?.relatedPersons?.map((it) => ({
          label: `${it?.label} - ${it?.positionName}`,
          value: it?.value || it?.employeeCode,
        })) || [],
      note: res?.leaveReason,
      leaveManagers: res?.leaveManagers || [],
      approvals: (res?.approvals || [])?.map((item: any) => ({
        ...item,
        name: item?.approverName,
        value: item?.approverCode,
        label: `${item?.approverName} - ${item?.positionName || ""}`,
      })),
      files: res?.attachedFiles || [],
      numberChildren: res?.numberChildren ? String(res?.numberChildren) : null,
      ...listApproverCode,
    };
    const formLongTerm =
      res?.type === TypeSelect.SHORT_TERM
        ? {}
        : {
            fromDate: moment(res?.details[0]!?.fromDate),
            toDate: moment(res?.details[res?.details?.length - 1]!?.toDate),
            hexColor: res?.details[0]!?.hexColor,
            reasonName: res?.details[0]!?.reasonName,
            reasonCode: res?.details[0]!?.reasonCode,
            leaveReasonTypeName: res?.details[0]!?.leaveReasonTypeName,
            type: res?.details[0]!?.type,
            requireAttachFiles: res?.details[0]!?.requireAttachFiles || false,
            leaveReasonType: res?.details[0]!?.leaveReasonType,
            countWeekends: res?.details[0]!?.countWeekends,
            countHolidays: res?.details[0]!?.countHolidays,
            leaveReasonTypeMap: res?.details[0]!?.leaveReasonTypeMap || {},
            specificType: res?.details[0]!?.specificType || "",
            maxDayForFeMale: res?.details[0]!?.maxDayForFeMale || 0,
            minDayForFeMale: res?.details[0]!?.minDayForFeMale || 0,
            rangeDateUnitForFeMale:
              res?.details[0]!?.rangeDateUnitForFeMale || "",
          };
    yield put({
      type: getRequestLeaveDetailSuccess.type,
      payload: res,
    });
    yield put({
      type: formReqLeaveUpdate.type,
      payload: payloadForm,
    });
    yield put({
      type: formReqLeaveLongTermUpdate.type,
      payload: formLongTerm,
    });

    yield put({
      type: setEarlyRegistrationFormInput.type,
      payload: {
        registerLeaveId: res?.id,
      },
    });
  } catch (error: any) {
    toast.error(
      Object.keys(ErrorMessage).includes(error?.response?.data?.code)
        ? ErrorMessage[error?.response?.data?.code]
        : (error?.response?.data?.message ?? "Có lỗi xảy ra")
    );
    yield put({
      type: getRequestLeaveDetailFailed.type,
      payload: ErrorMessage[error?.response?.data?.code] ?? "Có lỗi xảy ra",
    });
  }
}

function* watchGetRequestLeaveDetail() {
  yield takeLatest(getRequestLeaveDetailStart.type, getRequestLeaveDetailWork);
}

export default function* getArriveLateDetailSaga() {
  yield all([watchGetRequestLeaveDetail()]);
}
